module.exports = __webpack_public_path__ + "img/st-1.3fe910b0.jpg";